import * as React from 'react'

import CtaButton from '../../components/CtaButton/CtaButton'
import Heading from '../../components/Heading/Heading'
import Image from '../../components/Image/Image'
import Rte from '../../components/Rte/Rte'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import styles from './sidebarQuestionBlock-style.css'

type Props = {
  avatar?: ImageViewModel
  heading?: string
  text?: string
  cta?: LinkViewModel
}

class SidebarQuestionBlock extends React.Component<Props> {
  static displayName = 'SidebarQuestionBlock'
  static defaultProps = {}

  render() {
    const { avatar, heading, text, cta } = this.props

    return (
      <div className={styles.sidebarQuestionBlock}>
        {avatar && (
          <div className={styles.avatarWrapper}>
            <Image {...avatar} />
          </div>
        )}
        <div className={styles.textWrapper}>
          {heading && (
            <Heading level={2} tag={'h3'} className={styles.heading}>
              {heading}
            </Heading>
          )}
          {text && <Rte className={styles.textBlock} source={text} />}
          {cta && <CtaButton {...cta} />}
        </div>
      </div>
    )
  }
}

export default SidebarQuestionBlock